import { createContext } from 'react'

const posContext = createContext()

export default posContext
